import React from 'react';
import PageableTable from '@/components/table/PageableTable';
import { ScopeDto } from '../../../types';

const ScopesTable: React.FC<{ scopes: ScopeDto[] }> = ({ scopes }) => {
  const headers = ['Scope', 'Description', 'Service', 'Pii Access', 'Expiration Date'];
  const renderRow = (scope: ScopeDto, index: number) => (
    <tr key={index}>
      <td>{scope.name}</td>
      <td>{scope.description}</td>
      <td>{scope.service}</td>
      <td>{scope.piiAccess.toString()}</td>
      <td>{scope.expirationDate}</td>
    </tr>
  );

  return <PageableTable data={scopes} headers={headers} renderRow={renderRow} itemsPerPage={20} />;
};

export default ScopesTable;
